import { groupTagsByCategory, TripTagCategory } from "../components/tagSelect/tags";

export function packageCountries(pkg: { tags: { readonly category: string; readonly value: string }[] }) {
  return groupTagsByCategory(pkg.tags)[TripTagCategory.COUNTRY] ?? [];
}

export function packageGroupTypes(pkg: { tags: { readonly category: string; readonly value: string }[] }) {
  return groupTagsByCategory(pkg.tags)[TripTagCategory.GROUP_TYPE] ?? [];
}
